import HeroCard from "@components/ArticleCard/HeroCard";
import { useAutoplayOnBfcache } from "@src/app/hooks/useAutoplayOnBfcache";
import { useEmblaResize } from "@src/app/hooks/useEmblaResize";
import { useEmblaSelectedIndex } from "@src/app/hooks/useEmblaSelectedIndex";
import useIsSmallScreen from "@src/app/hooks/useIsSmallScreen";
import { useResponsivePadding } from "@src/app/hooks/useResponsivePadding";
import clsx from "clsx";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect } from "react";
import type { LinksFunction } from "react-router";

import styles from "./CarouselEmbla.css?url";
import { AUTOPLAY_SPEED, MIN_ARTICLES_FOR_CAROUSEL } from "./constants";
import CustomArrow from "./CustomArrow";
import type { CarouselProps } from "./types";
export const CarouselEmblaLinks: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
];

export default function CustomCarousel({ articles }: CarouselProps) {
  const [padding] = useResponsivePadding();
  const isSmallScreen = useIsSmallScreen();

  const autoplay = Autoplay({
    delay: AUTOPLAY_SPEED,
    stopOnInteraction: false,
    stopOnMouseEnter: true,
  });
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [autoplay]);

  useAutoplayOnBfcache(emblaApi);

  const selectedIndex = useEmblaSelectedIndex(emblaApi);
  useEmblaResize(emblaApi, isSmallScreen);

  useEffect(() => {
    console.log("Carousel render", emblaApi);
    emblaApi?.on("init", () => {
      console.log("embla init");
    });
  }, [emblaApi]);

  if (articles.length < MIN_ARTICLES_FOR_CAROUSEL) {
    return null;
  }

  return (
    <div className="w-full bg-secondary">
      <div className="relative m-auto max-w-screen-xxl pb-[28px] pt-[8px] lg:pb-[44px]">
        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {articles.map((article, index) => (
                <div className="embla__slide" key={article.id}>
                  <div
                    className={clsx(
                      "carousel-card-embla mx-auto",
                      selectedIndex == index && !isSmallScreen
                        ? "mt-[16px] !scale-[1.112] opacity-100"
                        : "!scale-100 opacity-60",
                    )}
                    key={article.id}
                  >
                    <HeroCard article={article} />
                  </div>
                </div>
              ))}
            </div>

            {/* custom dots */}
            <ul className="absolute !bottom-4 left-1/2 m-0 flex -translate-x-1/2 items-center justify-center p-0">
              {Array.from({ length: articles.length }).map((_, idx) => (
                <li
                  key={idx}
                  className="mx-1 my-0 flex h-2 items-center justify-center"
                >
                  <button
                    onClick={() => emblaApi?.scrollTo(idx)}
                    className={clsx(
                      "size-2 cursor-pointer rounded-full border-none bg-none p-0 text-[0px] before:block before:size-2 before:rounded-full before:bg-[#cacaca] before:content-['']",
                      selectedIndex === idx ? "before:bg-[#e11e27]" : "",
                    )}
                  >
                    {idx + 1}
                  </button>
                </li>
              ))}
            </ul>

            <CustomArrow
              direction="right"
              onClick={() => emblaApi?.scrollPrev()}
              isSmallScreen={isSmallScreen}
              padding={padding}
            />
            <CustomArrow
              direction="left"
              onClick={() => emblaApi?.scrollNext()}
              isSmallScreen={isSmallScreen}
              padding={padding}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
